export default __webpack_public_path__ + "static/media/exploded-view_sprite.35dad70d.png";